export enum Video {
    WEBM = "video/webm",
    OGV = "video/ogg",
    MPEG = "video/mpeg",
    MP4 = "video/mp4",
    MSVIDEO = "video/x-msvideo"
}
